import _regeneratorRuntime from "@babel/runtime/regenerator";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

import { statusActions } from "../../ISchema";

var buildClaimFormData = function buildClaimFormData(claim) {
  var formData = new FormData();

  for (var key in claim) {
    if (claim[key] !== null) formData.append("claim[".concat(key, "]"), claim[key]);
  }

  return formData;
};

export var createClaim = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(claim, token) {
    var formData, response, claimResponse;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            formData = buildClaimFormData(claim);
            _context.next = 4;
            return fetch("/api/v1/claims", {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context.sent;
            _context.next = 7;
            return response.json();

          case 7:
            claimResponse = _context.sent;
            return _context.abrupt("return", {
              status: statusActions.ok,
              payload: claimResponse
            });

          case 11:
            _context.prev = 11;
            _context.t0 = _context["catch"](0);
            console.error(_context.t0);
            return _context.abrupt("return", {
              status: statusActions.error
            });

          case 15:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[0, 11]]);
  }));

  return function createClaim(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();
export var editClaim = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(id, claim, token) {
    var formData, response, claimResponse;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            formData = buildClaimFormData(claim);
            _context2.next = 4;
            return fetch("/api/v1/claims/".concat(id), {
              method: "PUT",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 4:
            response = _context2.sent;
            _context2.next = 7;
            return response.json();

          case 7:
            claimResponse = _context2.sent;
            return _context2.abrupt("return", {
              status: statusActions.ok,
              payload: claimResponse
            });

          case 11:
            _context2.prev = 11;
            _context2.t0 = _context2["catch"](0);
            console.error(_context2.t0);
            return _context2.abrupt("return", {
              status: statusActions.error
            });

          case 15:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 11]]);
  }));

  return function editClaim(_x3, _x4, _x5) {
    return _ref2.apply(this, arguments);
  };
}();
export var uploadClaimDocument = /*#__PURE__*/function () {
  var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(claimId, formData, token) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            _context3.next = 3;
            return fetch("/api/v1/claims/".concat(claimId, "/claim_documents"), {
              method: "POST",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              },
              body: formData
            });

          case 3:
            response = _context3.sent;
            _context3.next = 6;
            return response.json();

          case 6:
            data = _context3.sent;
            return _context3.abrupt("return", {
              status: response.ok ? statusActions.ok : statusActions.error,
              payload: data
            });

          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            return _context3.abrupt("return", {
              status: statusActions.error,
              payload: _context3.t0
            });

          case 13:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[0, 10]]);
  }));

  return function uploadClaimDocument(_x6, _x7, _x8) {
    return _ref3.apply(this, arguments);
  };
}();
export var deleteClaimDocument = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(claimId, documentId, token) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return fetch("/api/v1/claims/".concat(claimId, "/claim_documents/").concat(documentId), {
              method: "DELETE",
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context4.sent;
            _context4.next = 6;
            return response.json();

          case 6:
            data = _context4.sent;
            return _context4.abrupt("return", {
              status: response.ok ? statusActions.ok : statusActions.error,
              payload: data
            });

          case 10:
            _context4.prev = 10;
            _context4.t0 = _context4["catch"](0);
            return _context4.abrupt("return", {
              status: statusActions.error,
              payload: _context4.t0
            });

          case 13:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4, null, [[0, 10]]);
  }));

  return function deleteClaimDocument(_x9, _x10, _x11) {
    return _ref4.apply(this, arguments);
  };
}();
export var fetchClaimDocuments = /*#__PURE__*/function () {
  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(claimId, token) {
    var response, data;
    return _regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return fetch("/api/v1/claims/".concat(claimId, "/claim_documents"), {
              headers: {
                Accept: "application/json",
                "X-CSRF-Token": token
              }
            });

          case 3:
            response = _context5.sent;
            _context5.next = 6;
            return response.json();

          case 6:
            data = _context5.sent;
            return _context5.abrupt("return", {
              status: response.ok ? statusActions.ok : statusActions.error,
              payload: data
            });

          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            return _context5.abrupt("return", {
              status: statusActions.error,
              payload: _context5.t0
            });

          case 13:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5, null, [[0, 10]]);
  }));

  return function fetchClaimDocuments(_x12, _x13) {
    return _ref5.apply(this, arguments);
  };
}();